export default "__VITE_ASSET__Cr62i_Wh__"